const routes = [
  {
    path: '/export',
    name: 'export',
    component: () => import('./index.vue'),
    meta: {
      title: 'Экспорт',
      role: ['admin'],
    },
  },
];

export default routes;
